export default {
    namespaced: true,
    state: {
        forms: []
    },
    mutations: {
        set_form(state, formObject) {
            state.forms.push({ name: formObject.name, data: formObject.data })
        },
        update_form(state, formObject) {
            // TODO: update existing form item
            const allOtherForms = state.forms.filter(
                (item) => item.name !== formObject.name
            )
            state.forms = allOtherForms
            state.forms.push({ name: formObject.name, data: formObject.data })
        }
    },
    actions: {
        setForm(context, formObject) {
            const exist = context.state.forms.find(
                (item) => item.name === formObject.name
            )
            if (!exist) {
                context.commit('set_form', formObject)
            } else {
                context.commit('update_form', formObject)
            }
        }
    }
}
